const ROOT = 'PAYMENT_METHOD_EDIT_DETAILS_ADD_CREDIT_CARD_';

const actions = {
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  ADD_CREDIT_CARD_REQUEST: `${ROOT}ADD_CREDIT_CARD_REQUEST`,
  ADD_CREDIT_CARD_SUCCESS: `${ROOT}ADD_CREDIT_CARD_SUCCESS`,
  ADD_CREDIT_CARD_ERROR: `${ROOT}ADD_CREDIT_CARD_ERROR`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
  CLEAR_CVV: `${ROOT}CLEAR_CVV`,
  SETUP_INTENT_CARD_REQUEST: `${ROOT}SETUP_INTENT_CARD_REQUEST`,
  SETUP_INTENT_CARD_SUCCESS: `${ROOT}SETUP_INTENT_CARD_SUCCESS`,
  CONFIRM_CARD_ADDED_REQUEST: `${ROOT}CONFIRM_BANK_ADDED_REQUEST`,
} as const;

export default actions;
